var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 102,
    viewBox: "0 0 100 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_365_8591)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 10C100 4.47716 95.5228 0 90 0L31.1803 0C27.3926 0 23.93 2.14002 22.2361 5.52786L2.23607 45.5279C0.82843 48.3431 0.82843 51.6569 2.23607 54.4721L22.2361 94.4721C23.93 97.86 27.3926 100 31.1803 100H90C95.5228 100 100 95.5229 100 90V10Z",
    fill: "url(#paint0_linear_365_8591)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 10C100 4.47716 95.5228 0 90 0L31.1803 0C27.3926 0 23.93 2.14002 22.2361 5.52786L2.23607 45.5279C0.82843 48.3431 0.82843 51.6569 2.23607 54.4721L22.2361 94.4721C23.93 97.86 27.3926 100 31.1803 100H90C95.5228 100 100 95.5229 100 90V10Z",
    fill: "#B7BCC2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 10C100 4.47716 95.5228 0 90 0L31.1803 0C27.3926 0 23.93 2.14002 22.2361 5.52786L2.23607 45.5279C0.82843 48.3431 0.82843 51.6569 2.23607 54.4721L22.2361 94.4721C23.93 97.86 27.3926 100 31.1803 100H90C95.5228 100 100 95.5229 100 90V10Z",
    fill: "#6B7787"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 52,
    width: 32,
    height: 4,
    rx: 2,
    transform: "rotate(-180 72 52)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_365_8591",
    x: 1.18042,
    y: 0,
    width: 98.8196,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_365_8591"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_365_8591",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_365_8591",
    x1: 50,
    y1: 100,
    x2: 50,
    y2: -0.00000271731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BAC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CBD6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.c402d4952e4400cdc47382f28a2e5680.svg";
export { ForwardRef as ReactComponent };